import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const shaharTrades: SeasonTrades[] = [
  {
    season: "2024/25",
    allTrades: [
        {
        otherTeam: manager.idan,
        sentAway: "Jabari Smith",
        gotInReturn: "Dereck Lively",
        amongBestTrades: true
      },
      {
        otherTeam: manager.dom,
        sentAway: "Dereck Lively",
        gotInReturn: "Lauri Markkanen and Benedict Mathurin",
        amongBestTrades: true
      },
      {
        otherTeam: manager.mati,
        sentAway: "Ivica Zubac",
        gotInReturn: "Jalen Johnson",
        amongBestTrades: true
      },
    ],
  },
];